import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Elements, Animations, Classes, Events } from '../global/constants';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed):not(.transition-clone)').each(function() {

		Animations.mobile.max.push(() => this.classList.remove(Classes.moving));

		Animations.mobile.min.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector(':scope .section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

				timeline.fromTo(
					image,
					{ y: () => offset() * (speed / 100), ease: 'none' },
					{ y: () => offset() * (-speed / 100), ease: 'none' }
				);
			}
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	$('.text-gallery-section').each(function() {
		const textGallerySection = this;

		const gallerySections = Elements.ContentWrapper.querySelectorAll('.gallery-move-section');

		gallerySections.forEach((section, index) => {
			const container = section.querySelector('.section-gallery');
			if(!container) return;

			const direction = section.classList.contains('left-direction') ? 'left' : 'right';

			const calculateTotalWidth = () => {
				let totalWidth = 0;

				Array.from(container.children).forEach(child => {
					const styles = window.getComputedStyle(child);
					const width = child.offsetWidth;
					const marginLeft = parseFloat(styles.marginLeft) || 0;
					const marginRight = parseFloat(styles.marginRight) || 0;
					totalWidth += width + marginLeft + marginRight;
				});
				return totalWidth;
			};

			const getScrollDistance = () => {
				const totalWidth = calculateTotalWidth();
				const viewportWidth = section.clientWidth || window.innerWidth;
				return Math.max(0, totalWidth - viewportWidth);
			};

			const isMobile = window.matchMedia('(max-width: 1024px)').matches;

			gsap.killTweensOf(container);
			if (window.ScrollTrigger) {
				ScrollTrigger.getAll().forEach(animation => {
					if (animation.vars && animation.vars.trigger === section) animation.kill();
				});
			}

			if (isMobile) {
				const distance = getScrollDistance();
				if (distance <= 1) {
					gsap.set(container, { x: 0 });
					return;
				}
				const avancement = 60;
				const duration = distance / avancement;
				const directionX = (direction === 'right') ? -distance : distance;

				gsap.set(container, { x: 0 });
				gsap.to(container, {
					x: directionX,
					duration,
					ease: 'none',
					repeat: -1,
					yoyo: true
				});
			} else {
				gsap.to(container, {
					x: () => direction === 'right' ? -getScrollDistance() : getScrollDistance(),
					ease: "linear",
					scrollTrigger: {
						trigger: section,
						start: "top bottom",
						end: "bottom+=100vh top",
						scrub: true,
						invalidateOnRefresh: true,
					}
				});
			}
		});
	});

	// ---------- TOC Highlighting ----------

	// Check if we're on a single post page with TOC
	if($('.post-summary .content').length > 0 && $('.post-content').length > 0) {

		const toc = $('.post-summary .content');
		const post = $('.post-content');

		Animations.lg.min.push(() => {
			// Add a CSS class to style the active TOC items

			// Create a ScrollTrigger for each heading
			gsap.timeline({
				scrollTrigger: {
					trigger: toc,
					start: 'top 10%', // When the heading reaches 30% from the top of the viewport
					endTrigger: post,
					end: 'bottom center', // When the heading's bottom passes 30% from the top
					pin: true,
					pinSpacing: false,
					//markers: true,
				}
			});
		});
	}

	// ---------- Menu ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
						(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					}
				}
			});
		});
	});
};

// Initialize scroll animations when the page enters
// Add a small delay to ensure all elements are properly rendered
$Elements.document.on(Events.page.enter, () => {
	initScrollAnimations()
});
